module.exports = __webpack_public_path__ + "img/Obstfelder_Charles_Baudelaire.ae675422.jpg";